import './style.scss'
import { Modal, Table, Tag } from 'antd'
import dayjs from 'dayjs'
import { FC, memo, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import * as homeApi from '@/api/home'

interface IProps {
  open: boolean
  onCancel?: () => void
}

const ContractListModal: FC<IProps> = (props) => {
  const { t: translate } = useTranslation(['personal', 'system'])
  const { open, onCancel } = props
  const [list, setList] = useState([])

  useEffect(() => {
    if (open) {
      getContractList()
    }
  }, [open])

  const getContractList = async () => {
    const res = await homeApi.getContractList()
    setList(res?.list || [])
  }

  const downloadContract = (url: string) => {
    location.href = url
  }

  return (
    <>
      <Modal
        className="common-modal contract-list-modal"
        onCancel={onCancel}
        footer={null}
        width={900}
        open={open}
        title={translate('personal.contract_management')}
      >
        <Table
          pagination={false}
          scroll={{ y: 400 }}
          columns={[
            {
              title: translate('personal.contract_number'),
              dataIndex: 'contract_no',
              width: 200
            },
            {
              title: translate('personal.create_time'),
              dataIndex: 'create_time',
              width: 160,
              render: (time: number) => (time ? <div>{dayjs(time * 1000).format('YYYY-MM-DD HH:mm')}</div> : '-')
            },
            {
              title: translate('personal.cooperation_start_time'),
              dataIndex: 'start_time',
              width: 160,
              render: (time: number) => (time ? <div>{dayjs(time * 1000).format('YYYY-MM-DD HH:mm')}</div> : '-')
            },
            {
              title: translate('personal.cooperation_end_time'),
              dataIndex: 'end_time',
              width: 160,
              render: (time: number) => (time ? <div>{dayjs(time * 1000).format('YYYY-MM-DD HH:mm')}</div> : '-')
            },
            {
              title: translate('personal.status'),
              dataIndex: 'status',
              width: 100,
              render: (status: number) => {
                if (status === 1) {
                  return <Tag>{translate('personal.not_effective')}</Tag>
                } else if (status === 2) {
                  return <Tag color="green">{translate('personal.effective')}</Tag>
                } else {
                  return <Tag color="gray">{translate('personal.expired')}</Tag>
                }
              }
            },
            {
              title: translate('personal.action'),
              width: 100,
              render: (_, data: any) =>
                data.download_url ? (
                  <a onClick={downloadContract.bind(this, data.download_url)}>{translate('personal.download')}</a>
                ) : (
                  ''
                )
            }
          ]}
          locale={{
            emptyText: <div style={{ padding: '40px 0' }}>{translate('personal.no_records')}</div>
          }}
          dataSource={list || []}
        ></Table>
      </Modal>
    </>
  )
}

export default memo(ContractListModal)
